var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-empty"},[_vm._m(0),_c('div',{staticClass:"empty-text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("../assets/noclass.png"),"alt":"暂无数据"}})])
}]

export { render, staticRenderFns }